/**
 * @flow
 */
'use strict';


export const ocularMedicationDosageCodes = [
{"code":"1 gtt"},
{"code":"2 gtt"},
{"code":"3 gtt"},
{"code":"5 gtt"},
]

export const ocularRouteCodes = [
{"code":"OD"},
{"code":"OS"},
{"code":"OU"}
]

export const ocularMedicationCodes = [
{"code":"Acular"},
{"code":"Alphagan"},
{"code":"Azarga"},
{"code":"Azopt"},
{"code":"Blink"},
{"code":"Brimonidine"},
{"code":"Buckle"},
{"code":"Celluvisc"},
{"code":"Ciprofloxacin"},
{"code":"Combigan"},
{"code":"Cosopt"},
{"code":"Cromolin"},
{"code":"Diamox"},
{"code":"Duotrav"},
{"code":"Fucithalmic"},
{"code":"Homatropine"},
{"code":"Hylo"},
{"code":"Inflammase"},
{"code":"Iso-carpine"},
{"code":"Isopto tears"},
{"code":"LA visine"},
{"code":"Lacrilube"},
{"code":"Latanoprost"},
{"code":"Lidocaïne"},
{"code":"Lotemax"},
{"code":"Lumigan"},
{"code":"Muro 128"},
{"code":"Nevanac"},
{"code":"Ocuvite"},
{"code":"Omega 3"},
{"code":"Pataday"},
{"code":"Patanol"},
{"code":"Pilocarpine"},
{"code":"Polysporin"},
{"code":"Prednisolone"},
{"code":"Preservision"},
{"code":"Refresh optive"},
{"code":"Restasis"},
{"code":"Risperdal"},
{"code":"Simbrinza"},
{"code":"Systane"},
{"code":"Thera pearl"},
{"code":"Timolol"},
{"code":"Timoptic"},
{"code":"Tobradex"},
{"code":"Travatan"},
{"code":"Trusopt"},
{"code":"Vigamox"},
{"code":"Visine"},
{"code":"Vitalux"},
{"code":"Voltaren"},
{"code":"Xalacom"},
{"code":"Xalatan"},
{"code":"Zaditor"},
]
